import { NewUser } from 'shared/models/User';
import {
  secureRequest,
  securePostRequest,
  deleteRequest,
  putRequest,
} from 'utils/request';
import { UserColumns } from 'types/system';

const pageId = ['/users', '/users/edit', 'users/create'];
interface IParams {
  filter?: string;
  sortField: string;
  skipCount: number;
  recordCount: number;
}

export const getCurrentUser = () => secureRequest(`api/v1/auth/current/`);

export const getUsers = (params: IParams) =>
  secureRequest(
    `/api/v1/users?filter=${params.filter}&sortField=${params.sortField}&skipCount=${params.skipCount}&recordCount=${params.recordCount}`,
    pageId
  );

export const getBranchesRoles = () => secureRequest(`/api/v1/users/0`, pageId);

export const createUser = (body: NewUser) =>
  securePostRequest(
    `/api/v1/users/`,
    pageId
  )(body).then((res) => {
    return res;
  });
export const deleteUser = (id: number) =>
  deleteRequest(`/api/v1/users/${id}`, pageId);
export const getUser = (id: number) =>
  secureRequest(`/api/v1/users/${id}`, pageId);
export const editUser = (body: NewUser) =>
  putRequest(
    `/api/v1/users/${body.id}`,
    pageId
  )(body).then((res) => {
    return res;
  });

export const getUserInfo = () => secureRequest(`/api/v1/users/info`);

export const setUserColumnsRequest = (body: UserColumns) =>
  securePostRequest(`/api/v1/users/columns`)(body);

export const getUserColumnsRequest = (table: string) =>
  secureRequest(`/api/v1/users/columns?table=${table}`);

